module.exports = "/_next/static/images/0171d3de5332477a7ce62ed4c2c07404-image-right.jpg.webp";